import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface UpAnimationProps {
  children: ReactNode;
}

const UpAnimationSize: React.FC<UpAnimationProps> = ({ children }) => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  const variants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -100 },
  };

  return (
    <motion.div
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={inView ? 'visible' : 'exit'}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      style={{
        display: 'inline-block',  // Prevent full-width block behavior
        margin: 0,                // Ensure no extra space
        padding: 0,
      }}
    >
      {children}
    </motion.div>
  );
};

export default UpAnimationSize;